import { render, staticRenderFns } from "./AddGarmentToRunModal.vue?vue&type=template&id=da0aaa78&scoped=true&"
import script from "./AddGarmentToRunModal.vue?vue&type=script&lang=js&"
export * from "./AddGarmentToRunModal.vue?vue&type=script&lang=js&"
import style0 from "./AddGarmentToRunModal.vue?vue&type=style&index=0&id=da0aaa78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0aaa78",
  null
  
)

export default component.exports